module.exports = __webpack_public_path__ + "img/ibiyinka.daf6025a.png";